<template>
  <div class="page-container">
    <van-nav-bar
      left-text="返回"
      left-arrow
      @click-left="closePage"
      title="消费账户"
      @click-right="onClickLeft"
    />
  </div>
</template>

<script>
import { reactive, defineComponent, ref } from "vue";
import { NavBar, Icon, Button } from "vant";
import http from "../../api/dashboard";
import { uploadFile } from "../../api/index.js";
import timeReg from "@/common/utils/timeReg.js";
import flutter from "@/common/utils/flutter.js";
import map from "@/common/utils/map.js";
import Cookies from "js-cookie";
export default defineComponent({
  name: "consumerAccount",
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
  },
  setup() {
    const onClickLeft = () => history.back();
    return {
      onClickLeft,
    };
  },
});
</script>

<style lang="less" scoped="scoped">
</style>
